
export enum AlignBPREvent {
    SelectStarRouteOne = "select-starroute-one",
    ClosePassagePlan = "close-passage-plan",
    ShowStarRouteModal = "show-star-route-modal",
};

export enum NotificationMessageType {
    NoApprovedPlanMessage = "There is 60 hours until ETD, and it is time to review and update your voyage plan and submit and approve it. This has to be done 48 hours before ETD. You will be able to continue with your current voyage plan or select a StarRoute.",
    NoPlanMessage = "There is 60 hours until ETD, and it is time to plan your voyage plan and submit and approve it. This has to be done 48 hours before ETD. You will be able to select a StarRoute, upload a route or create an own route.",
    NoPlanMoreThan60Message = "It is not possible to approve the voyage plan with more than 60 hours to ETD. You will be prompted to provide the approval and submission when 60 hours remains before ETD."
}
